import { render, staticRenderFns } from "./discipline-single.vue?vue&type=template&id=23774936&scoped=true&"
import script from "./discipline-single.ts?vue&type=script&lang=ts&"
export * from "./discipline-single.ts?vue&type=script&lang=ts&"
import style0 from "./discipline-single.scss?vue&type=style&index=0&id=23774936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23774936",
  null
  
)

export default component.exports